import { ReportController } from './report.controller';

export class CardReportController extends ReportController {
}
